import { tokenExpirationDate } from '@/helpers/token'
import Cookie from '@/helpers/cookie'
import VueCookies from 'vue-cookies'

const mutations = {
  SET_USER_DETAILS (state, data) {
    state.details = data
  },
  SET_SESSION(state, token) {
    state.token.updateValue(token)
    .updateExpires(tokenExpirationDate(token))
    .setSession()
    VueCookies.set('jwt-login', state.token.value)

    // salvar resposta no cookies

    const rolesUser = JSON.parse(window.atob(token.split('.')[1]));

    state.roles = rolesUser.auth;

  },
  CLEAR_TOKEN (state) {
    state.token = new Cookie({ name: 'jwt-login' })
  },
  SET_ROLES_USER (state, data) {
    state.rolesUser = data
  },
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/users/mutations.js